import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import { FaPencilAlt, FaTrash } from 'react-icons/fa';
import Table from 'react-bootstrap/Table';
import Parse from 'html-react-parser';

import NoteAPI from '../../api/NoteAPI';
import ApiUiController from '../../controller/ApiUiController';
import LeadConst from '../../util/LeadConst';
import Display from '../../util/Display';
import Util from '../../util/Util';
import Const from '../../util/Constants';

class InnerNoteList extends React.Component {

  constructor(props) {
    super(props);
    this.model = reactLocalStorage.getObject(Const.Model).note;
    this.state = { inApiCall: true,  notes: [] };
    this.NoteCount = 0;
    this.Update = Util.isAllow(this.model.permission, Const.PermAdd);
    this.Delete = Util.isAllow(this.model.permission, Const.PermDelete);
  }
  
  componentDidMount() { this.loadNotes(this.props.id); }

  UNSAFE_componentWillReceiveProps(props) {
    if(props.id !== this.props.id) {
      this.setState({ ...this.state, inApiCall: true,  notes: [] });
      this.loadNotes(props.id);
    }
  }

  loadNotes = id => { NoteAPI.getInnerList(this.props.type, id, this.onReceived, this.onFail); };

  onFail = (res) =>{
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false })
  };

  onReceived = res => {
    this.NoteCount = res.count ? res.count : 0;
    if(this.props.onCount) {
      this.props.onCount('note', this.NoteCount);
    }
    this.setState({ inApiCall: false,  notes: res.data });
  }
  onDelete = indx => Util.confirmAlert('Delete', 'Are you sure you want to delete',
    'Delete', 'No', () => {
      this.setState({ ...this.state, inApiCall: true });
      NoteAPI.delete(this.state.notes[indx].id, this.onDeleteSuccess, this.onFail);
  });
  onDeleteSuccess = () => {
    Util.showNotification('Successful', 'NOte deleted successfully', 'success');
    this.props.reload();
  }

  showList = () => this.state.notes.map((note, _i) => (
    <tr key={`note_${_i + 1}`}>
      <td>{Util.serverStringToDisplayDateTime(note.created_date)}</td>
      <td>{Display.FieldValue(note, 'type', this.model.fields)}</td>
      <td>{Display.ModelLabelValue('user', note.created_by)}</td>
      <td>{Parse(Display.FieldValue(note, 'text', this.model.fields))}</td>
      <td>
      { this.Update ?
          <span onClick={evnt => this.props.edit(note, LeadConst.Note)} className="buttons update buttons-sm">
            <FaPencilAlt /> Edit
          </span>
          : null
        }
        { this.Delete ? <span onClick={() => this.onDelete(_i)} className="buttons delete buttons-sm"><FaTrash /> Delete</span>
          : null
        }
      </td>
    </tr>
  ));

  render() {
    let uiNotes = this.showList();
    if(this.state.notes.length === 0) uiNotes = <tr><td colSpan="6">No Records Found</td></tr>;
    return (
      <div className="row">
        <div className="col-md-12">
          <h2>{this.model.model_name}</h2>
          <ApiUiController inApiCall={this.state.inApiCall}>
            <Table striped bordered hover size='sm'>
              <thead>
                <tr>
                  <th>Date Time</th>
                  <th>Type</th>
                  <th>Sales Person</th>
                  <th>Text</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                { uiNotes }
              </tbody>
            </Table>
          </ApiUiController>
        </div>
      </div>
    );
  }
}
export default InnerNoteList;